import { useLocation } from "react-router-dom";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import EmployeeProfileCard from "./components/EmployeeProfileCard";
import { useExpenseDetails, useExpenseLog } from "../expense/hooks/useExpense";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
// import EmployeeProfileCard from "./components/EmployeeProfileCard";


const SingleDayExpenseView=()=>{
    const location=useLocation();
    console.log('location data',location?.state)
    const formattedDate = new Date(location?.state?.employeeData?.expenseDate)
  .toLocaleDateString("en-GB"); // "01/07/2025"

const finalDate = formattedDate.replace(/\//g, "-");

  const CustomStyle={
   imageContainer: {
      width: "75%",
      height: "50%",
      // borderRadius: "50%",
      overflow: "hidden",
      marginBottom: "16px",
      // backgroundColor: "#fff",
      marginLeft:'16xp'
    },
    image:{
      width:'100%',
      height:'100%',
      borderRadius:'50%',
      ObjectFit:'cover'
    }
}




const TableColumns =()=>[
    {
     name:'Title',
     selector:(row:{ExpenseHead:string})=>row.ExpenseHead ,
    //  width:'160px'  
    },
    {
     name:'Requested Amount',
     selector:(row:{ExpIlAmount:string})=>row.ExpIlAmount,
    //  width:'130px'  

    },
    {
     name:'Approved Amount',
     selector:( row:{ExpAprAmount:string})=>row.ExpAprAmount,
    //  width:'160px'  

    },
    {
     name:'Final Amount',
     selector:( row:{ExpFinalAmount:string})=>row.ExpFinalAmount,
    //  width:'160px'  

    },
    {
     name:'Town',
     selector:( row:{ExpNote:string})=>row.ExpNote,
    //  width:'160px' 
    wrap:true 

    },
   

]

const ExpenseLogTableColumns =()=>[
    {
     name:'Log Detail',
     selector:(row:{WfNote:string})=>row.WfNote ,
    //  width:'160px'  
    },
    {
     name:'Status',
     selector:(row:{WfTitle:string})=>row.WfTitle,
    //  width:'130px'  

    },
 {
  name: 'Log By',
  selector: (row: { FirstName: string; LastName: string }) => row.FirstName+' '+row.LastName,
  // width: '160px'
},
    {
     name:'Log Date & Times',
     selector:( row:{UpdatedAt:string})=>row.UpdatedAt.split('.')[0],
    //  width:'160px'  

    },
]

 const RequiredFiled = {
    Name:"Name",
    EmployeeCode:"EmployeeCode",
    Email:'Email',
    UserName: "Email",
    Role:"RoleName",
    Position:"PositionName",
    ReportTo:"ReportingToPositionName",
    Working:"tripType",
    Budget:"",
    PlaceOfWork:"expensePlacewrk",
    TotalRequested:"expenseReqAmt"
   
    // ProfilePicture: "ProfilePicture",
  };

    const { data: apiData } = useExpenseDetails({
      id: location?.state?.employeeData?.expId,
      enabled:  !! location?.state?.employeeData?.expId ,
    });
    
console.log('apiData_of_expense',apiData?.data)

 const {data: expenseLogData} = useExpenseLog({
      id:location?.state?.employeeData?.expId,
      params: {
        date:location?.state?.employeeData?.expenseDate ,
      },
      enabled:true,
    });

// console.log('expenseLog',expenseLogData)

const mergeWfLogsAndEmployee = () => {
  const mergedLogs = expenseLogData?.data?.wfLogs?.map((log: any) => {
    return {
      ...log,
      ...log.Employee, // merge Employee fields
      Employee: undefined // optionally remove the nested Employee object
    };
  });

  // console.log('Merged Logs:', mergedLogs);
  return mergedLogs;
};

console.log('data',mergeWfLogsAndEmployee())


    return(
        <div className="p-2">
        
         <PageHeader title={finalDate}/>
        <div className="row-md-3">
        <div className="col-md-12">
          <EmployeeProfileCard customStyles={CustomStyle} media={location?.state?.employeeData?.EmployeeMedia}  profileEdit={false}  requiredFields={RequiredFiled}  employeeData={location?.state?.employeeData}  showStatusToggle={false}  />
      </div>
      </div>
      <div className="row-md-3" style={{marginTop:'10px'}}>
        <div className="col-md-12">
          <BasicDataTable

          columns={TableColumns()}
          Title="Expense"
          data={apiData?.data||[]}
          search={false}
          />

        </div>
      </div>
       <div className="row-mb-3" style={{marginTop:'10px'}}>
        <div className="col-md-12">
          <BasicDataTable
          search={false}
          columns={ExpenseLogTableColumns()}
          Title="Expense Logs"
          data={mergeWfLogsAndEmployee()}
          
          />

        </div>
      </div>
        </div>
    )
}

export default SingleDayExpenseView;